import { Component, ViewChild, TemplateRef, Renderer2, OnChanges, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';

@Component({
  selector: 'app-qi',
  templateUrl: './qi.component.html',
  styleUrls: ['./qi.component.scss']
})

export class QiComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  infoIconSrc: string = '../../assets/img/info-yellow.png';

  isProcessing: boolean;
  dateCustomClasses: DatepickerDateCustomClasses[];
  qi: any = {};
  isDetailSectionFrozen: boolean = false;
  isDateSectionFrozen: boolean = false;
  isLoggingSectionFrozen: boolean = false;
  isInvestigationSectionFrozen: boolean = false;
  isCompleteSectionFrozen: boolean = false;
  elite_Action_EC_Risk: boolean = false; /* Exclusive privilege to edit action, effectiveness and risk check toggle button */
  elite_Investigation: boolean = false; /* Exclusive privilege to edit investigation toggle button and dropdown */
  skipValidationsWhileSwitchingUser: boolean = false;
  pdfDetailSearchText: string = '';
  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];
  isStageUsersSkipped: boolean = false;
  isAdditionalTabUser: boolean = false;
  attachAllDocuments: boolean = false;
  constructor(
    public router: Router,
    public dialog: MatDialog,
    public qmsService: qmsService,
    public message: messageService,
    public taskActionsHistoryComponent: TaskActionsHistoryComponent,
    private readonly snackBar: MatSnackBar,
    private readonly renderer: Renderer2,
    private readonly appService: AppService,
    public dependencyNavigationService: DependencyNavigationService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.qmsService.isUpdatingQiThroughDynBtn = false;

    Object.keys(this.qmsService.qiDropDowns).forEach(key => {
      if (key === 'selectedQiCoreBusinessArea' || key === 'selectedQiRootCauseType') {
        this.qmsService.qiDropDowns[key] = [];
      } else {
        this.qmsService.qiDropDowns[key] = null;
      }
    })

    this.isAdditionalTabUser = this.qmsService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.appService.getTaskStages(qmsService.activityId, 0).subscribe((stageUser: any) => {
      this.isStageUsersSkipped = !stageUser.length;
    })
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;

  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }
  openGroupMethod() { this.topNavigationComponent.opengroupPopup(); }

  dropDownForDepartmentCode: any = [];
  dropDownForQiType: any = [];
  dropDownForRequestedAt: any = [];
  dropDownForCoreBusinessArea: any = [];
  dropDownForCoreBusinessAreaName: any = [];
  dropDownDataForImpactType: any = [];
  dropDownForQualityReference: any = [];
  dropDownForQa: any = [];
  dropDownForEvaluator: any = [];
  dropDownForEvaluationResult: any = [];
  dropDownForEvaluationRejectReason: any = [];
  dropDownForInvestigator: any = [];
  dropDownForRootCauseType: any = [];
  dropDownForResolutionCategory: any = [];

  departmentCodeDropdown: any = [];
  qiTypeDropDown: any = [];
  requestedAtDropdown: any = [];
  coreBusinessAreaNameDropdown: any = [];
  impactTypeDropdown: any = [];
  qualityReferenceDropdown: any = [];
  qaDropDown: any = [];
  evaluatorDropDown: any = [];
  evaluationResultDropDown: any = [];
  evaluationRejectReasonDropDown: any = [];
  investigatorDropDown: any = [];
  rootCauseTypeDropDown: any = [];
  resolutionCategoryDropDown: any = [];

  typeSearchText: string = '';
  departmentSearchText: string = '';
  referenceSearchText: string = '';
  requestedSearchText: string = '';
  coreBusinessSearchText: string = '';
  evaluatorSearchText: string = '';
  impactTypeSearchText: string = '';
  qaSearchText: string = '';
  investigatorSearchText: string = '';
  rootCauseSearchText: string = '';
  resolutionSearchText: string = '';

  oddType: any = null;
  oddDepartment: any = null;
  oddReference: any = null;
  oddRequestedAt: any = null;
  oddEvaluator: any = null;
  oddImpactType: any = null;
  oddQA: any = null;
  oddInvestigator: any = null;
  oddResolution: any = null;

  coreBusinessAreaFieldValue: any;
  businessAreaName: any;
  requestedAtFieldValue: any;
  isForVendor: boolean;
  visibleReferenceIfOthers: boolean;

  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  objForDocuments: any;

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  getColor(status: any) {
    if (status) {
      if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
        return 'red';
      } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
        return 'orange';
      } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
        return 'green';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.initiate();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qmsService.moduleName == 'QI') {
        this.initiate();
      }
    });
  }

  private initiate(): void {
    this.isProcessing = true;
    this.ngOnChangesReportFooter();
    this.main();
    this.getDynamicLabel();
    this.selectedTabIndex = 0;
  }

  label: any = [];
  dynamicLabel: any = null;
  getDynamicLabel() {
    this.isProcessing = true;

    const data = {
      tableName: 'QMS_QI_GRID_VW',
      moduleName: 'QI',
      gridName: 'QI',
      groupId: this.qmsService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qmsService.activityDynamicLabel = acc;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  main() {

    this.objForDocuments = { id: this.qmsService.activityId, pagename: "Activity" };

    const groupId = this.qmsService.selectedActivityGroupId;
    const groupDetailId = this.qmsService.selectedGroupDetailData.groupDetailId;
    const moduleName = this.qmsService.moduleName;
    const getQmsBusinessAreaDetails$ = this.appService.getAllQmsBusinessAreas();
    const getCodeListsByImpactType$ = this.appService.getCodeListsByGroup("QI_IMPACT_TYPE");
    const getCodeListsByIncidentReference$ = this.appService.getCodeListsByGroup("QUALITY_ISSUE_REFERENCE");
    const getCodeListByRootCauseType$ = this.appService.getCodeListsByGroup("QI_ROOT_CAUSE_TYPE");
    const getCodeListByResolutionCategory$ = this.appService.getCodeListsByGroup("QI_RESOLUTION_CATEGORY");
    const getQaUsers$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, 'QA')
    const getEvaluators$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, "Evaluator");
    const getInvestigators$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, "Investigator");
    const getTypeSettings$ = this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId);
    const getReportTemplate$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, this.qmsService.selectedGroup);
    const getOrgReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qmsService.selectedActivityGroupId);
    const getParallelWorkflow$ = this.appService.getWorkflowByRefNo(this.qmsService.activityId);
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    forkJoin([
      getQmsBusinessAreaDetails$,
      getCodeListsByImpactType$,
      getCodeListsByIncidentReference$,
      getCodeListByRootCauseType$,
      getCodeListByResolutionCategory$,
      getQaUsers$,
      getEvaluators$,
      getInvestigators$,
      getTypeSettings$,
      getReportTemplate$,
      getOrgReportImage$,
      getReportLogo$,
      getParallelWorkflow$
    ]).pipe(
      switchMap(([businessArea, impactType, reference, rootCauseType, resolutionCategory, qa, evaluator, investigator, typeSettings, getReportTemplate,
        reportImage, reportLogo, parallelWorkflow]) => {

        const x: any = businessArea;
        this.dropDownForRequestedAt = x?.filter((item: any) => item.module === this.qmsService.moduleName);

        this.dropDownDataForImpactType = impactType;
        this.selectBoxForImpactType();

        this.dropDownForQualityReference = reference;
        this.selectBoxForQualityReference();

        this.dropDownForRootCauseType = rootCauseType;
        this.selectBoxForRootCauseType();

        this.dropDownForResolutionCategory = resolutionCategory;
        this.selectBoxForResolutionCategory();

        this.dropDownForQa = qa;
        this.selectBoxForQa();

        this.dropDownForEvaluator = evaluator;
        this.selectBoxForEvaluator();

        this.dropDownForInvestigator = investigator;
        this.selectBoxForInvestigator();

        this.dropDownForQiType = typeSettings;
        this.selectBoxForQiType();

        this.dropDownDataForReportTemplate = getReportTemplate;
        this.selectBoxForReportTemplate();

        this.organizationReportImageDetails = reportImage;

        this.dropDownDataForReportLogo = reportLogo;
        this.selectBoxForReportLogo();

        this.parallelWorkflowList = parallelWorkflow;

        return this.appService.getQiVwDetailsByQiNo(this.qmsService.activityId);
      })
    ).subscribe(qiDetails => {

      this.qi = qiDetails;

      this.qmsService.validateQiAntiDraftFields = this.qi.status != 'Draft' && this.qi.status != 'Raised' && this.qi.status != 'More Information Requested By Evaluator';
      if (this.qi.status === 'Closed') this.checkEcHasData();
      else this.message.showEffectiveSection = false;

      this.selectBoxForDepartment();
      this.selectBoxForRequestedAt();

      this.qi.createdOn = new Date(this.qi.createdOn);
      this.qi.identifiedOn = new Date(this.qi.identifiedOn);
      this.qi.expectedToBeStartedOn = new Date(this.qi.expectedToBeStartedOn);
      this.qi.expcetedClosureOn = new Date(this.qi.expcetedClosureOn);
      this.qi.startedOn = this.qi.startedOn ? new Date(this.qi.startedOn) : null;
      this.qi.groupReassignedOn = this.qi.groupReassignedOn ? new Date(this.qi.groupReassignedOn) : null;
      this.qi.completedOn = this.qi.completedOn ? new Date(this.qi.completedOn) : null;
      this.qi.lastActionOn = this.qi.lastActionOn ? new Date(this.qi.lastActionOn) : null;
      this.qi.investigationRequestedOn = this.qi.investigationRequestedOn ? new Date(this.qi.investigationRequestedOn) : null;
      this.qi.investigationCompletedOn = this.qi.investigationCompletedOn ? new Date(this.qi.investigationCompletedOn) : null;
      this.qi.qaApprovalRequestedOn = this.qi.qaApprovalRequestedOn ? new Date(this.qi.qaApprovalRequestedOn) : null;
      this.qi.qaApprovedOn = this.qi.qaApprovedOn ? new Date(this.qi.qaApprovedOn) : null;

      this.qi.effectivenessCheckReqd = this.qi.effectivenessCheckReqd == "Y";
      this.qi.investigationRequired = this.qi.investigationRequired == "Y";
      this.qi.actionItemsReqd = this.message.showActionSection = this.qi.actionItemsReqd == "Y";
      this.message.showPreActionsTab = this.qi.preActionItemsReqd = this.qi.preActionItemsReqd == "Y";
      this.qi.seriousBreachAssessmentFormRequired = this.qi.seriousBreachAssessmentFormRequired == "Y";
      this.qi.usersToBeIntimatedPostEvaluation = this.qi.usersToBeIntimatedPostEvaluation == 'Y';
      this.qi.isRiskCalculationReqd = this.qi.isRiskCalculationReqd == "Y";

      this.qmsService.activity = this.qi;
      this.setDropdowns();
      this.getDynamicButtons();
      this.getStageUsers();
      this.ngOnChanges();

      this.isProcessing = false;
    });
  }

  ngOnChanges() {
    this.qmsService.refereshBreadCrumb = true;
  }

  private setDropdowns(): void {
    const matchingDepartment = this.dropDownForDepartmentCode?.find((item: any) => item.codelistCode === this.qi.deptCode);
    if (!matchingDepartment) {
      this.oddDepartment = this.qi.deptCode;
      this.departmentCodeDropdown.push({
        valueExp: this.qi.deptCode,
        displayExp: this.qi.deptCode
      })
    }
    this.qmsService.qiDropDowns.selectedQiDepartment = this.qi.deptCode;

    const matchingQiType = this.dropDownForQiType?.find((item: any) => item.type === this.qi.qiType);
    if (!matchingQiType) {
      this.oddType = this.qi.qiType;
      this.qiTypeDropDown.push({
        valueExp: this.qi.qiType,
        displayExp: this.qi.qiType
      })
    }
    this.qmsService.qiDropDowns.selectedQiType = this.qi.qiType;

    this.visibleReferenceIfOthers = this.qi.reference.toLowerCase().trim() == 'others';
    const matchingReference = this.dropDownForQualityReference?.find((item: any) => item.codelistCode === this.qi.reference);
    if (!matchingReference) {
      this.oddReference = this.qi.reference;
      this.qualityReferenceDropdown.push({
        valueExp: this.qi.reference,
        displayExp: this.qi.reference
      })
    }
    this.qmsService.qiDropDowns.selectedQiReference = this.qi.reference;

    const matchingRequestedAt = this.dropDownForRequestedAt?.find((item: any) => item.taskRequestedAt === this.qi.requestedAt);
    if (!matchingRequestedAt) {
      this.oddRequestedAt = this.qi.requestedAt;
      this.requestedAtDropdown.push({
        valueExp: this.qi.requestedAt,
        displayExp: this.qi.requestedAt
      })
    }
    this.qmsService.qiDropDowns.selectedQiRequestedAt = this.businessAreaName = this.qi.requestedAt;

    setTimeout(() => {
      const selectedBusinessArea = this.isBusinessAreaEmpty ? this.qi.coreBusinessAreaName : this.qi.coreBusinessAreaName?.split(',') ?? [];
      this.qmsService.qiDropDowns.selectedQiCoreBusinessArea = selectedBusinessArea;

      if (!this.isBusinessAreaEmpty) this.isAllBusinessAreaSelected = this.qmsService.qiDropDowns.selectedQiCoreBusinessArea.length == this.coreBusinessAreaNameDropdown.length;
    }, 1500);

    const matchingImpactType = this.dropDownDataForImpactType?.find((item: any) => item.codelistCode === this.qi.impactType);
    if (!matchingImpactType) {
      this.oddImpactType = this.qi.impactType;
      this.impactTypeDropdown.push({
        valueExp: this.qi.impactType,
        displayExp: this.qi.impactType
      })
    }
    this.qmsService.qiDropDowns.selectedQiImpactType = this.qi.impactType;

    if (this.qi.evaluator) {
      const matchingEvaluator = this.dropDownForEvaluator?.find((item: any) => item.userId === this.qi.evaluator);
      if (!matchingEvaluator) {
        this.oddEvaluator = this.qi.evaluator;
        this.evaluatorDropDown.push({
          valueExp: this.qi.evaluator,
          displayExp: this.qi.evaluatorUser
        })
      }
      this.qmsService.qiDropDowns.selectedQiEvaluator = this.qi.evaluator;
    }

    if (this.qi.qaUser) {
      const matchingQa = this.dropDownForQa?.find((item: any) => item.userId === this.qi.qaUser);
      if (!matchingQa) {
        this.oddQA = this.qi.qaUser;
        this.qaDropDown.push({
          valueExp: this.qi.qaUser,
          displayExp: this.qi.qaUsrUserName
        })
      }
      this.qmsService.qiDropDowns.selectedQiQa = this.qi.qaUser;
    }

    if (this.qi.investigator) {
      const matchingInvestigator = this.dropDownForInvestigator?.find((item: any) => item.userId === this.qi.investigator);
      if (!matchingInvestigator) {
        this.oddInvestigator = this.qi.investigator;
        this.investigatorDropDown.push({
          valueExp: this.qi.investigator,
          displayExp: this.qi.investigatorUser
        })
      }
      this.qmsService.qiDropDowns.selectedQiInvestigator = this.qi.investigator;
    }

    if (this.qi.rootCauseType) {
      this.qmsService.qiDropDowns.selectedQiRootCauseType = this.qi.rootCauseType?.split(',');
      this.isAllRootCause = this.qmsService.qiDropDowns.selectedQiRootCauseType.length == this.rootCauseTypeDropDown.length;
    }

    if (this.qi.resolutionCategory) {
      const matchingResolutionCategory = this.dropDownForResolutionCategory?.find((item: any) => item.codelistCode === this.qi.resolutionCategory);
      if (!matchingResolutionCategory) {
        this.oddResolution = this.qi.resolutionCategory;
        this.resolutionCategoryDropDown.push({
          valueExp: this.qi.resolutionCategory,
          displayExp: this.qi.resolutionCategory
        })
      }
      this.qmsService.qiDropDowns.selectedQiResolutionCategory = this.qi.resolutionCategory;
    }
  }

  private processButtonLabels(buttonLabels: string[] | null): string[] {
    const labels = buttonLabels ? [...buttonLabels] : [];
    labels.unshift("Cancel");  // Always add Cancel
    this.qmsService.activityDynamicButtonList = labels;

    // Reset flags
    this.qmsService.showflexifieldshow = false;
    this.qmsService.activitySaveButton = false;

    for (const element of labels) {
      if (/Submit|Review|Approve|Accept/.test(element)) {
        this.qmsService.showflexifieldshow = true;
      }
      if (element === "Save") {
        this.qmsService.activitySaveButton = true;
      }
    }
    return labels;
  }

  private getDynamicButtons() {
    const obj = {
      activityId: this.message.activityId,
      moduleName: this.qmsService.moduleName,
      status: this.qi.status
    }

    this.appService.getQmsButtons(obj).subscribe((data: any) => {
      this.qmsService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qmsService.activitySaveButton = false;

      if (data.resultType === "S") {
        this.qmsService.showflexifieldshow = false;
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qmsService.activityButtonLabels = data;
        this.buttonLabels = this.processButtonLabels(data.buttonLabels?.split(",") || null);

      } else {
        this.buttonLabels = this.processButtonLabels(null);
        this.showSnackBar(data.result, data.resultType);
      }
    });
  }

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index;
    this.qmsService.selectedTabName = $event.tab.textLabel;
    this.callStatusMethod();
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getQiVwDetailsByQiNo(this.qmsService.activityId).subscribe((qi: any) => {
        this.qi.expcetedClosureOn = this.qmsService.activity.expcetedClosureOn = new Date(qi.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  selectBoxForQiType() {
    this.qiTypeDropDown = [];
    this.qiTypeDropDown = this.dropDownForQiType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onQiTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('qi-type-validation', item);
      if (item) {
        this.isProcessing = true;
        this.appService.getTypeSettingsByType(this.qmsService.selectedActivityGroupId, this.qmsService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
          if (response.toBeStartedInDays) {
            const date = new Date();
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setDate(date.getDate() + response.toBeStartedInDays);
            this.qmsService.activity.expectedToBeStartedOn = date;
            this.onNgModelChange(this.qmsService.activity.expectedToBeStartedOn, 'expected-to-be-started-on-validation')
          }
          if (response.toBeClosedInDays) {
            const date = new Date();
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            this.qmsService.activity.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
            this.qmsService.activity.expcetedClosureOn = date;
            this.onNgModelChange(this.qmsService.activity.expcetedClosureOn, 'expected-closure-on-validation');
          }
          this.isProcessing = false;
        })
      }
    }
  }

  selectBoxForDepartment() {
    this.departmentCodeDropdown = [];
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('department-validation', item);
  }

  selectBoxForQualityReference() {
    this.qualityReferenceDropdown = [];
    this.qualityReferenceDropdown = this.dropDownForQualityReference?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onReferenceSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reference-validation', item);
      if (item) {
        if (item.displayExp == 'Others') [this.visibleReferenceIfOthers, this.qmsService.activity.referenceOthers] = [true, ''];
        else this.visibleReferenceIfOthers = false;
      }
    }
  }

  selectBoxForRequestedAt() {
    this.requestedAtDropdown = [];
    this.requestedAtDropdown = this.dropDownForRequestedAt?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []

    const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == this.qi.requestedAt);
    this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;

    if (!this.isBusinessAreaEmpty) {
      this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
      this.selectBoxForCoreBusinessAreaName();
    }
  }

  activityData: boolean;
  isBusinessAreaEmpty: boolean = false;
  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('requested-at-validation', item);
      if (item) {
        this.businessAreaName = item.displayExp;

        const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.coreBusinessAreaNameDropdown, this.qmsService.qiDropDowns.selectedQiCoreBusinessArea] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) });

      }
    }
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    this.coreBusinessAreaNameDropdown = this.dropDownForCoreBusinessArea?.map((value: any) => ({
      valueExp: value,
      displayExp: value
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;
  @ViewChild('rootCause') rootCause: MatSelect;
  isAllRootCause = false;

  toggleAllSelection(value: any) {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) this.businessArea.options.forEach((item: MatOption) => item.select());
      else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.qiDropDowns.selectedQiCoreBusinessArea = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('core-business-area-validation', this.qmsService.qiDropDowns.selectedQiCoreBusinessArea)
      });
    } else if (value == 'rootCause') {
      if (this.isAllRootCause) this.rootCause.options.forEach((item: MatOption) => item.select());
      else {
        this.rootCause.options.forEach((item: MatOption) => item.deselect());
        this.qmsService.qiDropDowns.selectedQiRootCauseType = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('root-cause-validation', this.qmsService.qiDropDowns.selectedQiRootCauseType)
      });
    }
  }

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('core-business-area-validation', this.qmsService.qiDropDowns.selectedQiCoreBusinessArea)
        this.isAllBusinessAreaSelected = this.coreBusinessAreaNameDropdown.length == this.qmsService.qiDropDowns.selectedQiCoreBusinessArea.length;
      });
  }

  selectBoxForImpactType() {
    this.impactTypeDropdown = [];
    this.impactTypeDropdown = this.dropDownDataForImpactType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onImpactTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('impact-type-validation', item);
  }

  selectBoxForEvaluator() {
    this.evaluatorDropDown = [];
    this.evaluatorDropDown = this.dropDownForEvaluator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onEvaluatorSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('evaluator-validation', item);
  }

  selectBoxForQa() {
    this.qaDropDown = [];
    this.qaDropDown = this.dropDownForQa?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onQaSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('qa-validation', item);
  }

  selectBoxForInvestigator() {
    this.investigatorDropDown = [];
    this.investigatorDropDown = this.dropDownForInvestigator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onInvestigatorSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('investigator-validation', item);
  }

  selectBoxForRootCauseType() {
    this.rootCauseTypeDropDown = [];
    this.rootCauseTypeDropDown = this.dropDownForRootCauseType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onRootCauseTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('root-cause-type-validation', this.qmsService.qiDropDowns.selectedQiRootCauseType);
        this.isAllRootCause = this.rootCauseTypeDropDown.length == this.qmsService.qiDropDowns.selectedQiRootCauseType.length;
      });
  }

  selectBoxForResolutionCategory() {
    this.resolutionCategoryDropDown = [];
    this.resolutionCategoryDropDown = this.dropDownForResolutionCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) ?? []
  }

  onResolutionCategorySelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('resolution-category-validation', item);
  }

  onInvestigationRequiredChange() {
    this.qmsService.qiDropDowns.selectedQiInvestigator = null;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {
    const editorTitleMapping: Record<string, any> = {
      'Description': this.dynamicLabel?.['DESCRIPTION']?.fieldName,
      'Impact Description': this.dynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName,
      'Investigation Summary': this.dynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName,
      'Occurrence Reason': this.dynamicLabel?.['OCCURANCE_REASON']?.fieldName,   // Note spelling OCCURANCE as in your code
      'Root Cause': this.dynamicLabel?.['ROOT_CAUSE']?.fieldName,
      'Final Impact Assessment': this.dynamicLabel?.['FINAL_IMPACT_ASSESSMENT']?.fieldName,
      'Conclusion': this.dynamicLabel?.['CONCLUSION']?.fieldName,
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qmsService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qmsService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  }

  identifiedOnConfig = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  expectedToBeStartedOnConfig = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  onExpectedToBeStartedOnChange() {
    if (this.qmsService.activity.expcetedClosureOn && (this.qmsService.activity.expcetedClosureOn < this.qmsService.activity.expectedToBeStartedOn)) this.qmsService.activity.expcetedClosureOn = null;
  }

  generateExpectedClosureDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.qmsService.activity.expectedToBeStartedOn ? new Date(this.qmsService.activity.expectedToBeStartedOn) : new Date()
    }
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      400: ['REQUESTED_AT'],
      4000: ['SHORT_DESCRIPTION', 'REFERENCE_OTHERS', 'ASSESSMENT_COMMENT', 'CLOSURE_COMMENT', 'RESOLUTION_PROVIDED', 'TYPE_UPDATE_JUSTIFICATION'],
      1000: ['REQUESTED_AT']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  onStEditorChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  skipValidation: boolean = false;
  async update(): Promise<boolean> {

    try {
      this.qmsService.validatedQiArray = [];
      const validationPromises: Promise<void>[] = [];

      const isInitiator = this.qi.initiator == this.message.getUserId();
      const isEvaluator = this.qi.evaluator == this.message.getUserId();
      const isInvestigator = this.qi.investigator == this.message.getUserId();
      const status = this.qmsService.activity.status;

      if (!this.skipValidationsWhileSwitchingUser && !this.skipValidation) {
        if ((isInitiator && status == 'Draft') || status == 'More Information Requested By Evaluator') {
          validationPromises.push(this.validateQiDetails(), this.validateQiDates());
        } else if (isEvaluator && [
          'Evaluation Completed', 'Logged', 'QA Approved', 'Reviewer Requested More Info.', 'Review Rejected',
          'Approver Requested More Info.', 'Approval Rejected', 'Closure Reviewer Requested More Info.', 'Closure Review Rejected',
          'Closure Approver Requested More Info.', 'Closure Approval Rejected', 'QA Rejected'].includes(status)) {
          validationPromises.push(this.validateQiDetails(), this.validateQiDates(), this.validateQiLogs());
        } else if (isInvestigator && (status == 'Investigation Pending' || status == 'Reinvestigation Requested')) {
          validationPromises.push(this.validateQiInvestigation());
        } else if (isEvaluator && status == 'In Progress') {
          validationPromises.push(this.validateQiCompletion());
        }
      }

      await Promise.all(validationPromises);

      const isValid = !this.qmsService.validatedQiArray.includes('Failed');
      if (!isValid) {
        this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
        return false;
      }

      this.isProcessing = true;
      const obj = await this.prepareObj(this.qmsService.activity, this.qmsService.qiDropDowns);

      return new Promise<boolean>((resolve) => {
        this.appService.updateQmsQi(obj).subscribe({
          next: (Response: any) => {
            this.message.lastmsg = Response;

            if (Response.resultType === 'S') {
              this.initiate();
              if (this.skipValidationsWhileSwitchingUser) {
                this.skipValidationsWhileSwitchingUser = false;
              } else if (this.flexibleComponent.flexibleFields.length) {
                this.flexibleComponent.save('activity', this.qmsService.activityId);
              }

              if (this.qmsService.isUpdatingQiThroughDynBtn) {
                this.qmsService.isUpdatingQiThroughDynBtn = false;
              } else {
                this.showSnackBar(Response.result, Response.resultType);
              }

              resolve(true);
            } else {
              this.showSnackBar(Response.result, Response.resultType);
              resolve(false);
            }
            this.isProcessing = false;
          },
          error: (error: Error) => {
            this.isProcessing = false;
            resolve(false);
            throw error;
          }
        });
      });

    } catch (error) {
      console.error('Error occurred during validation:', error);
      return false;
    }
  }

  private async prepareObj(qi: any, dropdown: any) {
    return {

      groupId: this.qmsService.activity.groupId,
      qiNo: this.qmsService.activity.qiNo,
      shortDescription: this.qmsService.activity.shortDescription,
      description: qi.description,
      initiator: qi.initiator,
      qiType: dropdown.selectedQiType,
      deptCode: dropdown.selectedQiDepartment,
      requestedAt: dropdown.selectedQiRequestedAt,
      coreBusinessAreaName: this.isBusinessAreaEmpty ? dropdown.selectedQiCoreBusinessArea : dropdown.selectedQiCoreBusinessArea?.join(','),
      reference: dropdown.selectedQiReference,
      referenceOthers: qi.referenceOthers,
      identifiedOn: qi.identifiedOn ? this.appService.dateZoneConvertion(new Date(qi.identifiedOn)) : null,
      expectedToBeStartedOn: qi.expectedToBeStartedOn ? this.appService.dateZoneConvertion(new Date(qi.expectedToBeStartedOn)) : null,
      expcetedClosureOn: qi.expcetedClosureOn ? this.appService.dateZoneConvertion(new Date(qi.expcetedClosureOn)) : null,
      actionItemsReqd: qi.actionItemsReqd ? "Y" : "N",
      preActionItemsReqd: qi.preActionItemsReqd ? "Y" : "N",
      effectivenessCheckReqd: qi.effectivenessCheckReqd ? "Y" : "N",
      impactType: dropdown.selectedQiImpactType ?? null,
      impactDescription: qi.impactDescription,
      evaluator: dropdown.selectedQiEvaluator ?? null,
      assessmentComment: qi.assessmentComment,
      qaUser: dropdown.selectedQiQa ?? null,
      investigator: dropdown.selectedQiInvestigator ?? null,
      investigationRequired: qi.investigationRequired ? "Y" : "N",
      investigationSummary: qi.investigationSummary,
      occurrenceReason: qi.occurrenceReason,
      rootCauseType: dropdown.selectedQiRootCauseType?.map((rootCauseType: any) => rootCauseType).join(',') ?? null,
      rootCause: qi.rootCause,
      conclusion: qi.conclusion,
      finalImpactAssessment: qi.finalImpactAssessment,
      closureComment: qi.closureComment,
      resolutionProvided: qi.resolutionProvided,
      resolutionCategory: dropdown.selectedQiResolutionCategory ?? null,
      seriousBreachAssessmentFormRequired: qi.seriousBreachAssessmentFormRequired ? "Y" : "N",
      usersToBeIntimatedPostEvaluation: qi.usersToBeIntimatedPostEvaluation ? "Y" : "N",
      isRiskCalculationReqd: this.qmsService.activity.isRiskCalculationReqd ? "Y" : "N",
      typeUpdateJustification: qi.typeUpdateJustification
    }
  }

  async validateQiDetails(): Promise<void> {
    const qi = this.qmsService.activity;
    const dd = this.qmsService.qiDropDowns;
    const validations = [
      { condition: !dd.selectedQiType, id: 'qi-type-validation' },
      { condition: this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y' && !dd.selectedQiDepartment, id: 'department-validation' },
      { condition: !dd.selectedQiReference, id: 'reference-validation' },
      { condition: dd.selectedQiReference?.toLowerCase().trim() == 'others' && !this.qmsService.activity.referenceOthers, id: 'reference-others-validation' },
      { condition: !dd.selectedQiRequestedAt, id: 'requested-at-validation' },
      { condition: this.isBusinessAreaEmpty ? !dd.selectedQiCoreBusinessArea : !dd.selectedQiCoreBusinessArea.length, id: 'core-business-area-validation' },
      { condition: !dd.selectedQiEvaluator, id: 'evaluator-validation' },
      { condition: !qi.shortDescription, id: 'short-description-validation' },
      { condition: this.qmsService.validateQiAntiDraftFields && (!qi.description || this.isContentEmpty(qi.description)), id: 'description-validation' },
      { condition: this.qmsService.validateQiAntiDraftFields && !dd.selectedQiImpactType, id: 'impact-type-validation' },
      { condition: this.qmsService.validateQiAntiDraftFields && (!qi.impactDescription || this.isContentEmpty(qi.impactDescription)), id: 'impact-description-validation' }
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateQiDates(): Promise<void> {
    const qi = this.qmsService.activity;
    const validations = [
      { condition: !qi.identifiedOn, id: 'identified-on-validation' },
      { condition: this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && !qi.expectedToBeStartedOn, id: 'expected-to-be-started-on-validation' },
      { condition: !qi.expcetedClosureOn, id: 'expected-closure-on-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateQiLogs(): Promise<void> {
    const qi = this.qmsService.activity;
    const dd = this.qmsService.qiDropDowns;
    const validations = [
      { condition: this.dynamicLabel['ASSESSMENT_COMMENT'].isRemovable != 'Y' && !qi.assessmentComment, id: 'assessment-comments-validation' },
      { condition: qi.qaUser != 0 && !dd.selectedQiQa, id: 'qa-validation' },
      { condition: qi.investigationRequired && !dd.selectedQiInvestigator, id: 'investigator-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateQiInvestigation(): Promise<void> {
    const qi = this.qmsService.activity;
    const dd = this.qmsService.qiDropDowns;
    const validations = [
      { condition: this.dynamicLabel['INVESTIGATION_SUMMARY'].isRemovable != 'Y' && (!qi.investigationSummary || this.isContentEmpty(qi.investigationSummary)), id: 'investigation-summary-validation' },
      { condition: this.dynamicLabel['ROOT_CAUSE'].isRemovable != 'Y' && (!qi.rootCause || this.isContentEmpty(qi.rootCause)), id: 'root-cause-validation' },
      { condition: this.dynamicLabel['ROOT_CAUSE_TYPE'].isRemovable != 'Y' && dd.selectedQiRootCauseType.length < 1, id: 'root-cause-type-validation' },
      { condition: this.dynamicLabel['CONCLUSION'].isRemovable != 'Y' && (!qi.conclusion || this.isContentEmpty(qi.conclusion)), id: 'conclusion-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateQiCompletion(): Promise<void> {
    const qi = this.qmsService.activity;
    const dd = this.qmsService.qiDropDowns;
    const validations = [
      { condition: this.dynamicLabel['RESOLUTION_CATEGORY'].isRemovable != 'Y' && !dd.selectedQiResolutionCategory, id: 'resolution-category-validation' },
      { condition: this.dynamicLabel['RESOLUTION_PROVIDED'].isRemovable != 'Y' && !qi.resolutionProvided, id: 'resolution-provided-validation' },
      { condition: this.dynamicLabel['CLOSURE_COMMENT'].isRemovable != 'Y' && !qi.closureComment, id: 'closure-comments-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {
    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.qmsService.validatedQiArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed')
    if (invalidIds.length > 0) {
      this.selectedTabIndex = 0;
      this.fieldValidation(invalidIds);
    }
  }

  checkEcHasData() {
    this.appService.getQmsTasksEC(this.qmsService.activityId).subscribe((data: any) => {
      this.message.showEffectiveSection = data.length ?? this.qmsService.activity.effectivenessCheckReqd;
    })
  }

  taskStageUsers: any = [];
  getStageUsers() {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.qi.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.qi.qiNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
        this.callStatusMethod();
      });
    } else {
      this.callStatusMethod();
    }
  }

  callStatusMethod() {
    const status = this.qmsService.activity.status;
    const loggedUserId = +this.message.getUserId();
    const isInitiator = this.qmsService.activity.initiator == loggedUserId;
    const isEvaluator = this.qmsService.activity.evaluator == loggedUserId;
    const isQa = this.qmsService.activity.qaUser == loggedUserId;
    const isEditableByQa = this.qmsService.selectedGroupDetailData.editableByQA == "Y";
    const isInvestigator = this.qmsService.activity.investigator == loggedUserId;
    const isEditableByInvestigator = this.qmsService.selectedGroupDetailData.editableByInvestigator == "Y";
    const isInvestigation = this.qmsService.activity.investigationRequired;
    const isActions = this.qmsService.activity.actionItemsReqd;
    const isPreActions = this.qmsService.activity.preActionItemsReqd;
    const isRisk = this.qmsService.activity.isRiskCalculationReqd && this.qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isEditableByReviewer = this.qmsService.selectedGroupDetailData.editableByReviewers == "Y";
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isEditableByApprover = this.qmsService.selectedGroupDetailData.editableByApprovers == "Y";

    if (status == "Draft" || status == 'More Information Requested By Evaluator') {
      this.qmsService.activitySaveButton = isInitiator;
      this.isDetailSectionFrozen = !isInitiator;
      this.isDateSectionFrozen = !isInitiator;
      this.message.showQiLoggingSection = false;
      this.message.showInvestigationSection = false;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isInitiator;
      this.message.showActionSection = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isInitiator;
      this.message.showDependancySection = false;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isInitiator;
    } else if (status == "Deleted" || status == "Raised" || status == "Evaluation Rejected - Closed") {
      this.qmsService.activitySaveButton = false;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = false;
      this.message.showInvestigationSection = false;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = false;
      this.message.showActionSection = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = false;
      this.message.showDependancySection = false;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = false;
    } else if (status == "Evaluation Completed" || status == "Logged" || status == "QA Rejected") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = !isEvaluator;
      this.isDateSectionFrozen = !isEvaluator;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = !isEvaluator;
      this.message.showInvestigationSection = false;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Pending QA Approval") {
      this.qmsService.activitySaveButton = isQa;
      this.isDetailSectionFrozen = !(isQa && isEditableByQa);
      this.isDateSectionFrozen = !(isQa && isEditableByQa);
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = !(isQa && isEditableByQa);
      this.message.showInvestigationSection = false;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isQa && isEditableByQa;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isQa && isEditableByQa;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isQa;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isQa && isEditableByQa;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isQa && isEditableByQa;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isQa && isEditableByQa;
    } else if (status == "QA Approved") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = false;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Investigator Requested More Information") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = !isEvaluator;
      this.message.showInvestigationSection = true;
      this.isInvestigationSectionFrozen = true;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Investigation Pending" || status == "Reinvestigation Requested") {
      this.qmsService.activitySaveButton = isInvestigator;
      this.isDetailSectionFrozen = !(isInvestigator && isEditableByInvestigator);
      this.isDateSectionFrozen = !(isInvestigator && isEditableByInvestigator);
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = !(isInvestigator && isEditableByInvestigator);
      this.message.showInvestigationSection = isInvestigator;
      this.isInvestigationSectionFrozen = !isInvestigator;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isInvestigator && isEditableByInvestigator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isInvestigator && isEditableByInvestigator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isInvestigator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isInvestigator && isEditableByInvestigator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isInvestigator && isEditableByInvestigator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isInvestigator && isEditableByInvestigator;
    } else if (status == "Investigation Completed") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = true;
      this.isInvestigationSectionFrozen = true;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Pending Review" || status == "Review Inprogress") {
      this.qmsService.activitySaveButton = false;
      this.isDetailSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.isDateSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isReviewer && isEditableByReviewer;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isReviewer && isEditableByReviewer;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isReviewer;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isReviewer && isEditableByReviewer;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isReviewer && isEditableByReviewer;
    } else if (status == "Pending Approval" || status == "Approval Inprogress") {
      this.qmsService.activitySaveButton = false;
      this.isDetailSectionFrozen = !(isApprover && isEditableByApprover);
      this.isDateSectionFrozen = !(isApprover && isEditableByApprover);
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = !(isApprover && isEditableByApprover);
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = !(isApprover && isEditableByApprover);
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isApprover && isEditableByApprover;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isReviewer;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isApprover && isEditableByApprover;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isApprover && isEditableByApprover;
    } else if (status == "Reviewer Requested More Info." || status == "Review Rejected" || status == "Approver Requested More Info." || status == "Approval Rejected") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteQiSection = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "In Progress") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteQiSection = true;
      this.isCompleteSectionFrozen = !isEvaluator;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = false;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = true;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = false;
    } else if (status == "Pending Closure Review" || status == "Closure Review Inprogress" || status == "Pending Closure Approval" || status == "Closure Approval Inprogress" || status == "Closed") {
      this.qmsService.activitySaveButton = false;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteQiSection = true;
      this.isCompleteSectionFrozen = true;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = false;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = status == "Closed" && isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = false;
      this.message.showExtensionSection = true;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = false;
    } else if (status == "Closure Reviewer Requested More Info." || status == "Closure Review Rejected" || status == "Closure Approver Requested More Info." || status == "Closure Approval Rejected") {
      this.qmsService.activitySaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showQiLoggingSection = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteQiSection = true;
      this.isCompleteSectionFrozen = true;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = true;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    }

    this.message.showEffectiveActionButtons = status == "Closed" && this.qmsService.userRole[0].qmsRoles.includes("Effectiveness Check Performer") && this.qmsService.userRole.length > 0;
    this.elite_Action_EC_Risk = isEvaluator && (status == "QA Approved" || status == "Investigation Completed" || status == "Reviewer Requested More Info." || status == "Review Rejected" || status == "Approver Requested More Info." || status == "Approval Rejected" || status == "Closure Reviewer Requested More Info." || status == "Closure Review Rejected" || status == "Closure Approver Requested More Info." || status == "Closure Approval Rejected" || status == "Investigator Requested More Information");
    this.elite_Investigation = isEvaluator && (status == "QA Approved");
    this.qmsService.elite_AccessToClosure_Reviewer_Approver = isEvaluator && (status == "In Progress");
    setTimeout(() => { this.setUpdateType(status) }, 1500);
    setTimeout(() => { this.flexibleComponent.main() });
  }

  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "evaluator") {
      this.qmsService.validSwitchStatus = status != 'Evaluation Rejected - Closed';
      return this.qmsService.validSwitchStatus;
    } else {
      this.qmsService.validSwitchStatus = status != 'Evaluation Rejected - Closed' && status != 'Closed'
      return this.qmsService.validSwitchStatus
    };
  }
  showUpdateType: boolean = false;
  private setUpdateType(status: string): void {

    const statuses = new Set([
      'Draft',
      'More Information Requested By Evaluator',
      'Raised',
      'Evaluation Completed',
      'Evaluation Rejected - Closed',
    ]);

    this.showUpdateType = !statuses.has(status);
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('taskActiomHistoryPopup', { static: true }) taskActionHistoryPopup: TemplateRef<any>;
  visibleTaskActiosHistoryPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  taskActionHistoryPopupConfig = {
    width: '130%',
    height: '100%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  openTopicPopup() {
    this.message.communicatingFrom = this.qmsService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
  }

  openTaskActionsHistory() {
    this.taskActionsHistoryComponent.ngOnInit();
    this.visibleTaskActiosHistoryPopup = this.dialog.open(this.taskActionHistoryPopup, this.taskActionHistoryPopupConfig);
  }

  cancelTaskActiosHistoryPopup() {
    this.visibleTaskActiosHistoryPopup.close();
  }
  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }
  //PDF report code start

  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = this.dropDownDataForReportTemplate?.map((template: any) => ({
      valueExp: template?.qmsReportTemplateVwPk.templateId,
      displayExp: template?.templateName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  templateid: number;
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = '#005c8a';
      }
    }
  }

  onReportTemplateRemoved(item: any) {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (!this.selectedReportTemplateValue) {
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = 'red';
      }
    }
  };
  openExportPopup() {
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }
  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReportGenerateFuntion() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      let data1: any = {};

      this.qi.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.qi.userId = y

      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qmsService.activity.groupId + "",

        "gridName": "QI",
        "templateId": this.selectedReportTemplateValue,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "QI_Report",
        "currentStatus": this.qmsService.activity.status,
        "groupName": thirdL[1],
        "QIid": this.message.activityId,
        "version": "0",
        "QIId": this.qmsService.activity.qiId

      }
      this.isProcessing = true;
      this.appService.genRateQIReport(data1).subscribe((response: any) => {
        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }
  //PDF report code end

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qmsService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qmsService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;

  async openSwitchUser(userBeingSwitched: any) {
    if (this.qmsService.activity.status == "In Progress" && userBeingSwitched != "Evaluator" && await this.qmsService.validateExtension({ refNo: this.qmsService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }

    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Evaluator") {
      this.message.switchedUser = this.qmsService.qiDropDowns.selectedQiEvaluator;
      this.message.switchUserCurrentValue = this.qmsService.qiDropDowns.selectedQiEvaluator;
      this.message.switchUserdropDownList = this.evaluatorDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (userBeingSwitched == "Investigator") {
      this.message.switchedUser = this.qmsService.qiDropDowns.selectedQiInvestigator;
      this.message.switchUserCurrentValue = this.qmsService.qiDropDowns.selectedQiInvestigator;
      this.message.switchUserdropDownList = this.investigatorDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (userBeingSwitched == "QA") {
      this.message.switchedUser = this.qmsService.qiDropDowns.selectedQiQa;
      this.message.switchUserCurrentValue = this.qmsService.qiDropDowns.selectedQiQa;
      this.message.switchUserdropDownList = this.qaDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchuserComponent.openswitchuser(userBeingSwitched, "QI");
  }

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Evaluator") {
      this.qmsService.qiDropDowns.selectedQiEvaluator = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Investigator") {
      this.qmsService.qiDropDowns.selectedQiInvestigator = this.message.switchedUser;
    } else if (this.message.switchuserRole == "QA") {
      this.qmsService.qiDropDowns.selectedQiQa = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchuserComponent.saveMethod();
    this.update();
    this.switchuserComponent.visibleswitchUserPopup.close();
    this.switchuserComponent.visibleConfirmationPopup.close();
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }
  addworkflow: boolean = false;
  parallelWorkflowList: any = [];
  async openAddWorkflow() {
    if (this.qmsService.activity.status == "In Progress" && await this.qmsService.validateExtension({ refNo: this.qmsService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addworkflow = true;
    this.isProcessing = false;
  };

  onworkflowChildValueEmitted() {
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qmsService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
    this.addworkflow = false;
  }

  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    const data = { pageName: 'Detail', labelName: "Tag", tagRef: this.qi.qiId }
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() { };

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {
              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  navigateToRisk() {
    this.goToTabByLabel("Risk Assessment");
  }

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  @ViewChild(ModuletypeComponent) moduleTypeComponent!: ModuletypeComponent;
  openModuleType: boolean = true;
  moduleTypeData: any;
  value: any;

  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.qiTypeDropDown,
      moduleTypeValue: this.qmsService.qiDropDowns.selectedQiType,
      expcetedClosureOn: this.qmsService.activity.expcetedClosureOn,
      expectedToBeStartedOn: this.qmsService.activity.expectedToBeStartedOn,
      moduleName: this.dynamicLabel['QI_TYPE'].fieldName,
      moduleStartedOnName: this.dynamicLabel['STARTED_ON'].fieldName,
      moduleclosedOnName: this.dynamicLabel['COMPLETED_ON'].fieldName
    }
    this.openModuleType = true;
    this.moduleTypeComponent.openpopup(this.moduleTypeData); //
  }

  onModuleTypeEmitted($event: any) {
    this.openModuleType = false;
    this.qmsService.qiDropDowns.selectedQiType = $event.moduleType;
    this.qmsService.activity.expcetedClosureOn = $event.expcetedClosureOn;
    this.qmsService.activity.expectedToBeStartedOn = $event.expectedToBeStartedOn;
    this.qmsService.activity.typeUpdateJustification = $event.typeUpdateJustification;
    this.skipValidation = true;
    this.update();
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        this.selectBoxForFooter();
        this.reportFooterDropdown.length && (this.selectedReportFooter = this.reportFooterDropdown[0].displayExp);
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

}

